const SENSITIVE_PATTERNS = [
  'token',
  'password',
  'secret',
  'apikey',
  'refreshtoken',
  'authorization',
  'credential',
]

const MAX_EVENTS = 200

export interface SecurityEvent {
  type: string
  timestamp: string
  details: Record<string, any>
}

const events: SecurityEvent[] = []

function redactValue(key: string): boolean {
  return SENSITIVE_PATTERNS.some((pattern) =>
    key.toLowerCase().includes(pattern),
  )
}

function redact(obj: Record<string, any>): Record<string, any> {
  if (!obj || typeof obj !== 'object') return obj

  const out: Record<string, any> = {}
  for (const key of Object.keys(obj)) {
    out[key] = redactValue(key) ? '[REDACTED]' : obj[key]
  }
  return out
}

export function logSecurityEvent(
  type: string,
  details: Record<string, any> = {},
): void {
  const event: SecurityEvent = {
    type,
    timestamp: new Date().toISOString(),
    details: redact(details),
  }

  events.push(event)
  if (events.length > MAX_EVENTS) events.shift()

  if (import.meta.env.DEV) {
     
    console.warn('[SecurityEvent]', event)
  }
}

export function getSecurityEvents(): SecurityEvent[] {
  return [...events]
}

export function setupCSPViolationListener(): void {
  document.addEventListener('securitypolicyviolation', (e) => {
    logSecurityEvent('csp-violation', {
      directive: e.violatedDirective,
      blockedURI: e.blockedURI,
      source: e.sourceFile,
      policy: e.originalPolicy,
    })
  })
}
